import { useAppDispatch } from 'app/hooks';
import { FilterBarDropdownProps } from 'common/components/filter/FilterBar.types';
import { statusDropdownConfiguration } from 'common/utils/StatusDropdownFilterConfiguration';

import { checkStatusFilter } from './claimUserMembershipSlice';

export const useClaimDropDownFiltersConfiguration = (): FilterBarDropdownProps[] => {
    const dispatch = useAppDispatch();

    const dropdownsConfig = [
        {
            dropdownInfo: statusDropdownConfiguration,
            dropdownReducer: (label: string) => {
                dispatch(checkStatusFilter(label));
            },
        },
    ];

    return dropdownsConfig;
};
